import script from "./SampleList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SampleList.vue?vue&type=script&lang=ts&setup=true"

import "./SampleList.vue?vue&type=style&index=0&id=2cdcbfd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cdcbfd2"]])

export default __exports__